import isEmpty from 'lodash/fp/isEmpty';

// revere of the lodash isEmpty function
const isNotEmpty = value => !isEmpty(value);

export default isNotEmpty;
